import { useState, useEffect } from 'react'
import Header from './components/Header'
import Hero from './components/Hero'
import Features from './components/Features'
import InterfaceShowcase from './components/InterfaceShowcase'
import Workflow from './components/Workflow'
import Footer from './components/Footer'

function App() {
  const [scrollY, setScrollY] = useState(0)

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Noise overlay for texture */}
      <div className="noise-overlay" />

      {/* Background grid */}
      <div className="fixed inset-0 bg-grid-pattern bg-[size:60px_60px] pointer-events-none opacity-40" />

      {/* Radial gradient vignette */}
      <div className="fixed inset-0 bg-gradient-radial from-transparent via-crafter-base/80 to-crafter-base pointer-events-none" />

      <Header scrollY={scrollY} />

      <main className="relative">
        <Hero />
        <Features />
        <InterfaceShowcase />
        <Workflow />
      </main>

      <Footer />
    </div>
  )
}

export default App
